import { Injectable } from '@angular/core';
import { catchError, Observable, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../models/auth.model';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }

  // public methods
  login(email: string, password: string, cftoken?: string, verify?: string): Observable<any> {
    const fcmToken = localStorage.getItem('fcmToken');
    return this.http.post<AuthModel>(`${API_USERS_URL}/auth2`, JSON.stringify({
      user: email,
      password,
      verify,
      cftoken,
      fcmToken
    })).pipe(
      map(response => {
        // console.log('response ', response);
        return response ?? []
      })
    )
  }
  
  // public methods
  verifyLogin(session: string, code: string, owner_code: string): Observable<any> {
    return this.http.post<AuthModel>(`${API_USERS_URL}/auth2/verify`, JSON.stringify({
      session: session,
      code: code,
      owner_code: owner_code
    }));
  }

  changePassword(auth: string, currentPass: string, newPassword: string): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + auth
      })
    };

    return this.http.post<any>(`${environment.apiUrl}/password`, JSON.stringify({
      current: currentPass,
      password: newPassword
    }), httpOptions); // Add httpOptions here
  }

  changePhotoProfile(auth: string,body: FormData){
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + auth
      })
    };
    return this.http.post<any>(`${environment.apiUrl}/user/photo`, body, httpOptions); // Add httpOptions here
  }

  logout(auth: string): Observable<any> {
      let httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' +  auth
        })
      }
      return this.http.get<string>(`${environment.apiUrl}/logout`, httpOptions).pipe(
        catchError((err) => {
          throw 'Request failed:' + err;
      }))
  }


  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_USERS_URL, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(body: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${API_USERS_URL}/user/forgotpassword`, body);
  }

  getUserByToken(token: string): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel>(`${API_USERS_URL}/me`, {
      headers: httpHeaders,
    });
  }

  registerTOTP(token: string){
    
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/auth2/totp/register`, {
      headers: httpHeaders,
    }); // Add httpOptions here
  }

  verifyRegisterTOTP(auth: string, code: string){
    let httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + auth
      })
    };
    return this.http.post<any>(`${environment.apiUrl}/auth2/totp/registerverify`, JSON.stringify({
      code: code
    }), httpOptions); // Add httpOptions here
  }

}
